import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/supplier-group/$id')({
    beforeLoad: ({ params }) => {
        // Redirect to new pluralized route
        throw redirect({
            to: '/supplier-groups/$groupId',
            params: { groupId: params.id },
        });
    },
});
